<atn-ds-table [config]="resourcesTableConfig" />
